import script from "./Registration.vue?vue&type=script&setup=true&lang=ts"
export * from "./Registration.vue?vue&type=script&setup=true&lang=ts"

import "./Registration.vue?vue&type=style&index=0&id=5184e0eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5184e0eb"]])

export default __exports__